<template>
  <div>
    <div style="height: 200px;background-size: 100% 100%;display: flex;align-items: center;width: 100%;"
      :style="{ backgroundImage: 'url(' + require('@/assets/images/applications/hero.jpg') + ')' }">
      <!-- <img src="../../assets/images/applications/hero.jpg"> -->
      <div style="padding-left: 250px;width: 1200px;margin: 0px auto;">
        <div style="font-size: 40px;">定制应用</div>
        <div class="ctext" style="font-size: 16px;margin-top: 25px;">精准匹配业务场景的专属应用方案，开箱即用，快速赋能</div>
      </div>
    </div>
    <div class="file" style="width: 1200px;margin: 0px auto;margin-bottom: 80px;">
      <div style="width: 200px;background: #f5f5f5;padding:20px 18px;">
        <div v-for="(x, i) in apps" style="padding:10px 0px;">
          <div @click="setTitle(i)" style="cursor: pointer;" class="file falign">
            <div style="background: #35a9b1;border-radius: 10px;"><img style="height: 40px;width: 40px;"
                :src="action + x.logosrc"></div>
            <div style="margin-left:15px ;font-size: 18px;font-weight: bold;">{{ x.name }}</div>
            <div v-if="i == mindex" style="margin-left:20px ;font-size: 20px;font-weight: 300;"><img style="width:15px;"
                src="../../assets/home/xia.png"></div>
            <div v-else style="margin-left:20px ;font-size: 20px;font-weight: 300;"><img
                style="width: 9px;position: relative;left:3px;" src="../../assets/home/you.png"></div>
          </div>
          <div v-if="i == mindex" style="margin-top: 15px;">
            <div @click="getInfo(z.ID)" :class="[{ 'mtext': z.ID == mtext }, { 'menu': mtext != z.ID }]"
              style="cursor: pointer;;padding:8px 0px;text-align: center;background: #fff;font-size: 14px;margin: 6px 0px;border-radius:5px ;"
              v-for="z in x.children">{{ z.name }}</div>
          </div>
        </div>
      </div>
      <div style="padding:35px 55px;flex: 1;">
        <div class="file falign">
          <div v-if="data.logo" style="margin-right: 25px;"><img :src="action + data.logo"
              style="width: 40px;height: 44px;"></div>
          <div style="">
            <div style="font-size: 20px;font-weight: bold;" class="cprimary">{{ data.title }}</div>
            <div class="ftext" style="margin-top: 5px;">{{ data.text }}</div>
          </div>
        </div>
        <div style="margin-top: 50px;" v-if="data.info">
          <div class="file falign">
            <div style="font-size: 24px;color: #1e66d1;">◆</div>
            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">详情</div>
          </div>
          <div style="margin-top: 20px;font-size: 14px;line-height: 25px;">
            {{ data.info }}</div>
        </div>
        <div style="margin-top: 50px;" v-if="data.infos.length > 0">
          <div class="file falign">
            <div style="font-size: 24px;color: #1e66d1;">◆</div>
            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">优势</div>
          </div>
          <div style="margin-top: 28px;">
            <div v-for="x in data.infos">
              <div style="font-size: 14px;font-weight: bold;margin-top: 15px;">{{ x.title }}</div>
              <div style="font-size: 14px;margin-top: 15px;margin-left: 23px;">{{ x.text }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 50px;" v-if="data.imgs || data.imgsb">
          <div class="file falign">
            <div style="font-size: 24px;color: #1e66d1;">◆</div>
            <div style="font-size: 18px;font-weight: bold;margin-left: 15px;">功能展示</div>
          </div>
          <div class="file" style="margin-top: 30px;margin-left: 5px;width: 100%;flex-wrap: wrap;">
            <div v-for="(x, i) in data.imgs" style="margin-right: 25px;width: 22%;">
              <div style="box-shadow:rgba(176, 176, 176, 0.5) 0px 3px 20px 1px;width: 100%;height: auto;"><img
                  style="width: 100%;height: auto;" :src="action + x"></div>
              <div style="font-size: 14px;text-align: center;margin-top: 20px;">{{ data.imgstext[i] }}</div>
            </div>
          </div>
          <div style="margin-top: 30px;margin-left: 5px;width: 100%;flex-wrap: wrap;">
            <div v-for="(x, i) in data.imgsb" style="margin-bottom: 60px;">
              <div style="box-shadow:rgba(176, 176, 176, 0.5) 0px 3px 20px 1px;width: 100%;height: auto;"><img
                  style="max-width: 100%;height: auto;" :src="action + x"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
export default {
  data() {
    return {
      action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
      mindex: 0,
      mtext: '',
      apps: [],
      data: {infos:[]},
    }
  },
  created() {
    this.$http('/App/GetTypeData').then(x => {
      if (x.data.length > 0) {
        var data = getJsonTree(x.data, '', 'pid')
        this.apps = data
        this.load()
      }
    })
  },
  activated() {
    // this.$http('/App/GetTypeData').then(x => {
    //   if (x.data.length > 0) {
    //     var data = getJsonTree(x.data, '', 'pid')
    //     this.apps = data
    //     this.load()
    //   }
    // })
    var id = this.$route.query.id
    if (id) {
      this.apps.forEach((x, i) => {
        x.children.forEach((z, j) => {
          if (z.ID == id) {
            this.mindex = i
            this.getInfo(z.ID)
          }
        })
      })
    } else if (this.$route.query.title) {
      this.apps.forEach((item,i) => {
        item.children.forEach(z => {
          console.log(z)
          if (z.name == this.$route.query.title) {
            this.mindex = i
            this.getInfo(z.ID)
          }
        })
      });
    }
  },
  methods: {
    load() {
      var id = this.$route.query.id
      if (id) {
        this.apps.forEach((x, i) => {
          x.children.forEach((z, j) => {
            if (z.ID == id) {
              this.mindex = i
              this.getInfo(z.ID)
            }
          })
        })
      } else {
        this.setTitle(0)
      }
    },
    setTitle(i) {
      this.mindex = i
      this.getInfo(this.apps[i].children[0].ID)
    },
    getInfo(ID) {
      this.mtext = ID
      this.$http('/App/GetDetails', { typeid: ID }).then(x => {
        if (x.length > 0) {
          this.data = x[0]
          if (x[0].imgs) this.data.imgs = x[0].imgs.split(',')
          if (x[0].imgsb) this.data.imgsb = x[0].imgsb.split(',')
          if (x[0].imgstext) this.data.imgstext = x[0].imgstext.split(',')
        }
        else this.data = {}
      })
    }
  }
}
</script>
<style scoped>
.mtext {
  background: #1e66d1 !important;
  color: #fff;
}

.menu:hover {
  background: #fcfcfc !important;
  color: #1e66d1;
}

.transform {
  transform: rotate(90deg);
  display: inline-block;
  /* 确保文本占据空间，防止影响布局 */
  white-space: nowrap;
  font-size: 23px !important;
  margin-left: 18px !important;
}
</style>